/*
  C - WLP Trust Strip, mobile carousel (sections/c-wlp-trust-strip.liquid)
  - Below 990px the track is a sideways-scrolling row holding the claims twice.
  - It scrolls on its own at `data-speed` px/s without stopping; once the
    first copy is fully scrolled past it jumps back by one copy, so the loop
    never ends.
  - A swipe takes over while the finger is down; the loop resumes from where
    the swipe left it right after release. Off on desktop.
*/
(() => {
  const mobile = window.matchMedia('(max-width: 989px)');

  const initCarousel = (track) => {
    if (track.dataset.wlpReady === 'true') return;
    track.dataset.wlpReady = 'true';

    const lists = track.querySelectorAll('.c-wlp-trust__list');
    if (lists.length < 2) return;
    const speed = Math.max(Number(track.dataset.speed) || 40, 5);
    let pos = track.scrollLeft;
    let last = 0;
    let frame = 0;
    let touching = false;
    let resumeAt = 0;

    const copyWidth = () => lists[1].offsetLeft - lists[0].offsetLeft;

    const tick = (now) => {
      frame = window.requestAnimationFrame(tick);
      const dt = last ? Math.min(now - last, 100) : 0;
      last = now;
      if (touching || now < resumeAt) {
        pos = track.scrollLeft;
        return;
      }
      const width = copyWidth();
      if (width <= 0) return;
      // Re-sync if something else moved the row (inertia after a swipe).
      if (Math.abs(track.scrollLeft - pos) > 2) pos = track.scrollLeft;
      pos += (speed * dt) / 1000;
      if (pos >= width) pos -= width;
      track.scrollLeft = pos;
    };

    const start = () => {
      window.cancelAnimationFrame(frame);
      last = 0;
      if (mobile.matches) frame = window.requestAnimationFrame(tick);
    };

    track.addEventListener('touchstart', () => { touching = true; }, { passive: true });
    track.addEventListener('touchend', () => { touching = false; resumeAt = performance.now() + 600; }, { passive: true });
    track.addEventListener('touchcancel', () => { touching = false; }, { passive: true });
    track.addEventListener('scroll', () => {
      // A swipe can carry the row past the second copy: wrap it back.
      const width = copyWidth();
      if (touching && width > 0 && track.scrollLeft >= width) track.scrollLeft -= width;
    }, { passive: true });
    document.addEventListener('visibilitychange', () => { if (!document.hidden) last = 0; });
    mobile.addEventListener('change', start);
    start();
  };

  const initAll = (scope = document) => scope.querySelectorAll('[data-wlp-trust-carousel]').forEach(initCarousel);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll());
  else initAll();

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
